/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import classNames from 'classnames';

interface Props {
  className?: string;
}

export const PageHeaderBackground = ({ className }: Props) => {
  return (
    <div
      className={classNames(
        'fixed inset-0 -z-1',
        'h-45 w-full',
        'pointer-events-none',
        'mask-bottom',
        'after:bg-linear-to-t',
        'after:from-black after:from-10%',
        'after:to-transparent',
        'after:size-full',
        'after:absolute',
        'after:top-0',
        className,
      )}
    >
      <img
        src='/static/images/games/dbd/dbd-stats-header.jpg'
        className='size-full object-cover'
        alt=''
        role='presentation'
      />
    </div>
  );
};
